import { render, staticRenderFns } from "./PayoutSetup.vue?vue&type=template&id=05f429fb&scoped=true&"
import script from "./PayoutSetup.vue?vue&type=script&lang=js&"
export * from "./PayoutSetup.vue?vue&type=script&lang=js&"
import style0 from "./PayoutSetup.vue?vue&type=style&index=0&id=05f429fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f429fb",
  null
  
)

export default component.exports